<template>
  <v-dropdown-menu
    icon="chevron-down"
    style-type="secondary"
    size="sm"
    text="word.more"
  >
    <template v-slot:menu>
      <button
        v-for="action in extraActions"
        :key="action.name"
        :class="{'dropdown-item': !action.hidden, 'd-none': action.hidden}"
        type="button"
        @click="$emit('extra-action-clicked', action.name)"
      >
        <i
          class="fa mr-2 dropdown-icon"
          :class="[`fa-${action.icon}`]"
        ></i>
        {{ action.text }}
      </button>

      <hr v-if="extraActions.filter((action) => (!action.hidden)).length > 0"/>

      <button
        v-if="downloadEnabled"
        class="dropdown-item"
        type="button"
        @click="downloadChartAndClose($parent.$refs.chartDownload, name)"
      >
        <i class="fa fa-download mr-2 dropdown-icon"></i>
        {{ $t('word.download') }}
      </button>
      <button
        v-if="downloadEnabled"
        class="dropdown-item"
        type="button"
        @click="copyChartToClipboard"
      >
        <i
          class="fa fa-copy mr-2 dropdown-icon"
        ></i>
        {{ $t('word.copy') }}
      </button>
    </template>
  </v-dropdown-menu>
</template>

<script>
import DropdownMenu from '@/common/components/DropdownMenu.vue';
import { copyChart, downloadChart } from '@/organisation/services/charts';
import { notify } from '@/common/utils/notify';

export default {
  name: 'ChartDropdown',
  props: {
    extraActions: {
      type: Array,
      default: () => [],
    },
    downloadEnabled: {
      type: Boolean,
      default: true,
    },
    name: {
      type: String,
      required: true,
    },
  },
  components: {
    'v-dropdown-menu': DropdownMenu,
  },
  data() {
    return {
      copied: false,
    };
  },
  methods: {
    async downloadChartAndClose(chart) {
      await downloadChart(chart, this.name);
    },
    downloadChart,
    async copyChartToClipboard() {
      await copyChart(this.$parent.$refs.chartDownload, this.name);
      notify('phrase.copied_to_clipboard', null, 'success');
    },
  },
};
</script>

<style scoped>
.dropdown-icon {
  width: 1rem;
  text-align: center;
}
</style>
